<script setup>
import {inject} from "vue";
import {locationToUrl} from "@utils/utils.js";
const popup = inject('popup');

function closePopup() {
  popup.close();
  locationToUrl('/v2/student/index.html');
}
</script>

<template lang="pug">
  .popup-container
    h3 系統提醒：版本不支援
    p
      |你的系統版本有點舊，可能會讓畫面跑不出來，建議你把系統更新到：
      br
      span.alert iOS 17 以上 / Android：10 以上
      br
      |更新完再打開這個網頁，就可以正常使用囉！
    .button-container
      button.standard(@click="closePopup") 我知道了
</template>

<style scoped lang="sass">
@use '@assets/styles/common' as *
@use '@assets/styles/mixin' as *

.popup-container
  +flex(center)
  width: 400px
  padding: 40px
  flex-direction: column
  background-color: #fff
  border-radius: 16px
  box-shadow: 0px 0px 40px 0px rgba(25, 25, 25, 0.20)


.popup-container
  & > img
    +size(200px,auto)
    max-width: 100%
  & > h3
    +font(24px,500)
    line-height: 2
    color: #6B6B6B
  & > p
    +font(16px,500)
    line-height: 2
    color: #6B6B6B
    text-align: center

    & > span.alert
      color: #DF4C4C

.button-container
  width: 100%
  margin-top: 40px
</style>
